import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Header, Button } from 'semantic-ui-react';
import VehicleDisplay from './VehicleDisplay';
import styles from './AddLoanLeaseCoverage.module.scss';

const AddLoanLeaseCoverage = ({ vehicle, onBack, onCancel, onSaveAndExit, onContinue, addLoanLeaseCoverage }) => {
	const [_addLoanLeaseCoverage, setAddLoanLeaseCoverage] = useState(addLoanLeaseCoverage)
	
	return (
		<Form>
			<Header>Loan/Lease Coverage</Header>
			<p>If your car is totaled in an accident, the value of the car could be less than what you owe your bank or leasing company. That's because auto insurance covers your car but not your debt.</p>
			<p>Fortunately, there's an easy and affordable solution. Loan/lease coverage pays the difference between the actual cash value of your car and the greater amount you may owe on your car loan or lease.</p>

			<Form.Group inline>
				<label>Do you want to add loan/lease coverage?</label>
				<Form.Radio label='Yes' checked={_addLoanLeaseCoverage === true} onChange={() => setAddLoanLeaseCoverage(true)} />
				<Form.Radio label='No' checked={_addLoanLeaseCoverage === false} onChange={() => setAddLoanLeaseCoverage(false)} />
				<label>
					<VehicleDisplay vehicle={vehicle} />
				</label>
			</Form.Group>
			<p>Premium amount for the coverage will be based on the Comprehensive & Collision deductibles you select on the following screen.</p>

			<div className={styles.buttons}>
				<Button id="continueBtn" primary onClick={() => onContinue(_addLoanLeaseCoverage)} disabled={_addLoanLeaseCoverage === null}>Continue</Button>
				<Button id="saveAndExitBtn" primary onClick={onSaveAndExit}>Save and Exit</Button>
				<Button id="cancelBtn" primary onClick={onCancel}>Cancel</Button>
				<Button id="backBtn" primary onClick={onBack}>Back</Button>
			</div>
		</Form>
	);
};

AddLoanLeaseCoverage.propTypes = {
	vehicle: PropTypes.any.isRequired,
	onBack: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	onSaveAndExit: PropTypes.func.isRequired,
	onContinue: PropTypes.func.isRequired,
};

export default AddLoanLeaseCoverage;
